import { Button, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

export interface LoadMoreButtonProps {
  onClick: () => void;
  loading?: boolean;
}

export const LoadMoreButton = memo(function LoadMoreButton({
    onClick,
    loading = false
}: LoadMoreButtonProps) {
    const { t } = useTranslation('myJobs');

    return (
        <Root>
            <StyledButton
                variant="outlined"
                onClick={ onClick }
                disabled={ loading }
                startIcon={ loading ? <CircularProgress size={ 20 } /> : undefined }
            >
                { loading ? t('loadingMore') : t('loadMore') }
            </StyledButton>
        </Root>
    );
});

const Root = styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4, 0)
}));

const StyledButton = styled(Button)(({ theme }) => ({
    minWidth: '200px',
    padding: theme.spacing(1.5, 4)
}));

export default LoadMoreButton;
